import { motion } from "framer-motion";

const Mission = () => {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative bg-[#C48B71] text-[#F9F8F6] overflow-hidden"
    >
      <div className="grain absolute inset-0 opacity-[0.12] pointer-events-none" />
      <div className="mx-auto max-w-[1300px] px-6 md:px-10 lg:px-16 py-24 md:py-36 text-center relative">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.7 }}
          className="overline text-[#F9F8F6]/80"
        >
          Mission Statement
        </motion.p>

        <motion.blockquote
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          data-testid="mission-quote"
          className="serif italic text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-[1.15] tracking-tight mt-8 max-w-5xl mx-auto"
        >
          To capture your <span className="not-italic font-normal">Main Visions</span>
          <br />— the priceless, blink-and-you'll-miss-it moments that deserve
          to be remembered <span className="not-italic font-normal">forever</span>.
        </motion.blockquote>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-12 flex items-center justify-center gap-4"
        >
          <span className="h-px w-12 bg-[#F9F8F6]/40" />
          <span className="serif italic text-lg">What's your Main Vision?</span>
          <span className="h-px w-12 bg-[#F9F8F6]/40" />
        </motion.div>
      </div>
    </section>
  );
};

export default Mission;
